<template>
  <div class="searchIndex" @click="toggleSearchInputBind(false)">
    <!-- 顶部卡片 -->
    <div class="headerCont">
       <div class="pageTitle f_20 color_fff text_center color_40">根据职位、公司、学校、技能、专业等搜索人才</div>
      <div class="searchBox flex-c searchMore pr">
        <div class="flex1 pr searchInput bg_fff" style="padding-left:1px">
          <div class="inputPlaceholder f_14 color_90 input cursor_p" v-if="!searchInputState" @click.stop="toggleSearchInputBind(true)">请输入职位、公司、学校、技能、专业等关键词</div>
          <input v-model="keyword" placeholder="请输入职位、公司、学校、技能、专业等关键词" class="f_14 color_40 input pr bg_fff" ref="searchInputState" @keyup.enter="submit" @click.stop v-else/>
        </div>
        <div class="submit text_center iconfont iconsousuo color_fff font_w_b" @click="submit"></div>
        <div class="moreBox pa bg_fff" @click.stop>
          <template v-if="!myPosition.loading">
            <div class="moreBoxTitle f_14 color_60">
              <div>
                <span class="iconfont iconxiaohuomiao color_red" style="margin-right: 6px" />
                <span class="category-title">按线上职位搜索</span>
              </div>
            </div>
            <div class="myPosition clearfix" v-if="myPosition.list.length">
              <template  v-for="(item,index) in myPosition.list">
                <div class="Bitem fl" :key="String(index)" v-if="index<8">
                  <div class="item" @click="clickJobs(item,index)" data-growing-container data-growing-title='搜索主页在线职位'>
                    <div class="title ellipsis f_14 color_60">{{item.recruit_info.job_post}}</div>
                    <div class="text f_12 color_9c afterText">
                      <span v-if="item.cities">{{item.cities[0]}}</span>
                      <span v-if="item.display_degree">{{item.display_degree}}</span>
                      <span v-if="item.display_experience">{{item.display_experience}}</span>
                      <!-- <span v-if="item.salary">{{item.salary}}</span> -->
                      <span v-if="item.salary">{{(item.annual_month_salary && item.annual_month_salary > 12) ? `${item.salary} · ${item.annual_month_salary}薪` : `${item.salary}`}}</span>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <div class="fr color_60 cursor_p moreJobs" v-if="myPosition.list.length>8" @click="updateBlockStateFun({type: 'jobsPopUpsState', value:true})">查看全部 <span class="iconfont iconyemiantiaozhuan"></span></div>
            <p class="f_14 color_9c" v-if="!myPosition.list.length" style="margin-bottom: 16px">当前暂无在线职位，您可以点击 <a href="/talent/jobedit/create" target="_blank" class="color_blue">去发布</a></p>
          </template>

          <div class="moreBoxTitle f_14 color_60 category-title">热门搜索</div>
          <div class="hotJob clearfix">
            <div class="item fl f_14 color_60 cursor_p" v-for="(item, index) in hotSearch" :key="item" @click="clickHot(item)">
              {{item}}<span class="iconfont icondahuomiao color_red" v-if="index===0"></span><span class="iconfont iconzhonghuomiao color_red" v-if="index===1"></span><span class="iconfont iconxiaohuomiao color_red" v-if="index===2"></span>
            </div>
          </div>

          <template v-if="searchHistory.length">
            <div class="moreBoxTitle f_14 color_9c clearfix">
              <div>
                <span class="category-title">历史搜索</span>
              </div>
              <div class="fr iconfont iconGroup3 color_9c cursor_p" @click="clearHistory()"></div>
            </div>
            <div class="searchHistory clearfix">
              <template v-for="(item,index) in searchHistory">
                <div class="item fl f_14 color_60 cursor_p ellipsis" :key="String(index)" @click="clickHistory(item)" v-if="index<=9">{{item.name}}</div>
              </template>
              
            </div>
          </template>
          <!-- 筛选项 -->
          <!-- <template> -->
            <!-- <searchFilter :isSearchIndex="true" :selectedEducation="selectedEducation" :selectedSchool="selectedSchool" :selectedeXperience="selectedeXperience" -->
                         <!-- @checkFilter="checkFilter" @checkLatest="checkLatest" @resetFilter="resetFilter" /> -->
          <!-- </template> -->
        </div>
      </div>
    </div>

    <!-- 骨架图 -->
<!--    <div class="skeleton" v-if="myPosition.loading || !jobTypeList.length">-->
<!--      <skeletonDiagram />-->
<!--    </div>-->
    
    <!-- 已登录状态 没有发布职位或者jobTypeList小于2 -->
    <div class="indexCard bg_fff" v-if="!myPosition.loading && ((myPosition.list.length && jobTypeList.length && jobTypeList.length<2) || !myPosition.list.length) && isLogin">
      <div class='notfindResume pr' v-if="myPosition.list.length && jobTypeList.length && jobTypeList.length<2">
        <div class='tipsContent pa text_center'>
          <img src='https://files.wondercv.com/taro_searchResume_miniprogram/notfindResume.png' />
          <div class='text f_12 color_cf'>暂无推荐简历，可通过搜索发现更多人才</div>
        </div>
      </div>
      <!-- 发布职位 -->
      <template v-if="!myPosition.list.length">
        <div class="cardTitle clearfix color_40 f_14 font_w_b">
          <span class="iconfont iconzhiwei color_blue"></span>按在线职位搜索
        </div>
        <div class="myPositionTips f_14 color_60">
          当前暂无在线职位，您可以点击 <a href="javascript:;" class="color_blue" @click="toRecruitInfos">去发布</a>
        </div>
      </template>
    </div>

<!--    &lt;!&ndash; 未登录状态 列表展示 &ndash;&gt;-->
<!--    <div class="recommend flex" v-if="!isLogin">-->
<!--      &lt;!&ndash; 左侧筛选列表 &ndash;&gt;-->
<!--      <div class="recommendLeft flex1">-->
<!--        <div class="flex-c">-->
<!--          <div class="name f_20 color_40 font_w_b flex1">简历推荐</div>-->
<!--        </div>-->

<!--        <div class="recommendList">-->
<!--          &lt;!&ndash; 职位列表 &ndash;&gt;-->
<!--          <recommendCard :demoData="demoData" @customClick="handlerToLogin('/talent/search')"/>-->
<!--        </div>-->

<!--        <div class="login-wrapper bg_fff flex-c" @click="handlerToLogin('/talent/search')">-->
<!--          <p class="f_16"><a href="javascript:;" class="color_blue">登录</a>后即可查看更多优质简历</p>-->
<!--        </div>-->

<!--      </div>-->
<!--    </div>-->

    <!-- 已经有职位 -->
<!--    <div class="recommend flex" v-if="!myPosition.loading && jobTypeList.length>1">-->
<!--      &lt;!&ndash; 左侧筛选列表 &ndash;&gt;-->
<!--      <div class="recommendLeft flex1">-->
<!--        <div class="filter flex-c bg_fff">-->
<!--          <div class="name f_20 color_40 font_w_b flex1">简历推荐</div>-->
<!--          <div class="select f_14 color_40 cursor_p pr">-->
<!--            <div class="flex-c" :class="[jobRecommend.index!==0 ? 'active' : '']">-->
<!--              <div class="name flex1 ellipsis">{{jobRecommend.label}}</div>-->
<!--              <div class="iconfont iconxuanxiang-shouqi"></div>-->
<!--              &lt;!&ndash; <div class="iconfont iconliebiaoshaixuan-zhankai"></div> &ndash;&gt;-->
<!--            </div>-->
<!--            <div class="list pa bg_fff resetScrollBar">-->
<!--              <div class="item cursor_p f_14 ellipsis" :class="[index===jobRecommend.index ? 'color_blue' : 'color_9c']" v-for="(item,index) in jobTypeList" :key="String(index)" @click="jobRecommendChange({item,index})" >{{item.label}}</div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="recommendList" v-loading="jobRecommendLoading">-->
<!--          &lt;!&ndash; 职位列表 &ndash;&gt;-->
<!--          <recommendList @jobRecommendChange="jobRecommendChange" :jobRecommendIndex="jobRecommend.index" />-->
<!--        </div>-->

<!--      </div>-->
<!--    </div>-->
    
    <!-- 完善信息弹层 -->
    <userinfo-tips :jobId="resumeDetail.job_id"  @confirmGetPhone='confirmGetPhone' />

    <!-- 在线职位 -->
    <jobsPopUps v-if="jobsPopUpsState" />

    <div class="scrollTopButton iconfont iconfanhuidingbu" :class="[windowScrollTop>windowInnerHeight?'active':'']" @click="scrollTop">
      <div class="top-text">
        回到顶部
        <div></div>
      </div>
    </div>

  </div>
</template>

<script>
// 所有接口
import actions from '@/actions/index'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { } from '@/utils/utils'
import { Base64 } from 'js-base64';

import recommendList from '@/components/recommend/List'

import recommendCard from '@/components/searchList/cvCard'

import userinfoTips from '@/components/block/userinfoTips'
import jobsPopUps from '@/components/recommend/jobsPopUps'
import searchFilter from '@/components/searchList/searchFilter'
import skeletonDiagram from '@/components/skeletonDiagram/index'

import { checkUserState , get_tUser, toLogin } from '@/utils/utils';
import { queryFilter, checkCity } from './ListFilter'

import demoData from './data'

export default {
  name: 'searchIndex',
  data(){
    return {
      demoData: demoData,
      isLogin: false,
      keyword:'', //搜索关键字
      filterEdit:false, //搜索筛选编辑状态
      filter:['北京大学','清华','腾讯','产品','Java'], //保存的搜索筛选
      hotSearch:['产品经理','产品运营','前端开发','JAVA','Python','数据分析'], //热门搜索
      searchHistory:[],//历史搜索
      userToken:'',//cookie中登录用户的token
      userJWT:{}, //当前用户的一些jwt信息

      job_id:'',//匹配的职位id
      myPositionMore:false, //我发布的职位【更多】
      favoritesId:'', //是否自动收藏
      jobType:{
        '中专':'中专,高中,大专,本科,硕士,博士,MBA',
        '高中':'高中,大专,本科,硕士,博士,MBA',
        '大专':'大专,本科,硕士,博士,MBA',
        // '专科':'专科,本科,硕士,博士,MBA',
        '本科':'本科,硕士,博士,MBA',
        '硕士':'硕士,博士,MBA',
        '博士':'博士,MBA',
        'MBA':'MBA',
      },

      jobRecommendLoading:true,//是否加载jobRecommend
      searchInputState: false,//是否触发下拉菜单
      jobRecommend:{ //职位推荐
        label:'全部职位',
        index:0,
      },
      jobTypeList:[], //筛选

      showDetail:false,

      unsuitableDataState:false, //标记弹窗
      unsuitableIndex:-1,//不合适数据Index
      changeResume: {},
      selectedEducation:[], //学历选中数据
      selectedSchool:[],  //学校选中数据
      selectedeXperience:[], //经验选中数据
    }
  },
  computed:{
    ...mapState('block',['userInfoState', 'windowScrollTop', 'windowInnerHeight', 'checkUnsuitable', 'jobsPopUpsState']),
    ...mapState('resumeDetails',['routePageName', 'resumeDetailToken', 'resumeDetail', 'myPosition']),
    ...mapGetters('resumeDetails',[ 'getStoreResumeList'] ),
  },
  components:{
    // recommendList,
    // recommendCard,
    userinfoTips,
    jobsPopUps,
    // searchFilter
    // skeletonDiagram
  },
  async created(){
    this.updateRoutePageName(this.$route.name);
    this.userJWT = get_tUser();
    // 是否登录
    if (this.userJWT.h_t) {
      this.isLogin = true
    }
    //是hr
    if(this.userJWT.h_t){
    }else{
      let myPosition = this.myPosition;
      myPosition.loading = false;
      this.updateMyPosition(myPosition);
      //整理职位筛选数据
      this.jobTypeList = [{
        token:'',
        label:'全部职位'
      }]
      //不是hr
      return false;
    }
    if(this.userJWT.t){
      this.userToken = this.userJWT.t;
      if(this.userJWT.h_t){
        // 获取用户信息
        this.getUserinfo();
        // 获取职位列表
        this.getMyPosition();
        // 获取今日推荐简历
        // this.getRecommendAtions();
      }else{
        this.jobTypeList = [{
          token:'',
          label:'不限'
        }];
      }

      //重置loading状态
      this.updateMyPosition({ loading: true, list: [], index: -1 })

      //获取历史记录
      let searchHistory = localStorage.getItem('searchHistory');
      this.searchHistory =  searchHistory ? JSON.parse(searchHistory) : [];
    }
  },
  methods:{
    ...mapMutations('block',['toggleUserInfoState', 'updateBlockStateFun']),
    ...mapMutations('resumeDetails',['updateRoutePageName', 'updateResumeDetailToken', 'updateResumeDetail', 'updateMyPosition', 'updateListOptions', 'updateResumeListObj']),
    ...mapActions('resumeDetails',['getMyPosition']),
    // 左侧方法
    //切换是否查看最新简历
    checkLatest(){
      this.latest = this.latest ? 0 : 1;
      //重置参数，请求接口
      // this.resetQuery();
    },
    //切换左侧筛选
    checkFilter(options){
      let { type, item} = options;
      let list = [...this[type]];
      if(options.item === '不限'){
        this[type] = [];
      }else{
        let hasItem = false;
        let hasItemIndex = 0;
        this[type].forEach((sitem, index)=>{
          if(sitem === item){
            hasItem = true
            hasItemIndex = index;
          }
        })
        if(hasItem){
          this[type].splice(hasItemIndex,1);
        }else{
          this[type].push(item);
        }
      }
      if(list.length !== this[type].length){
        //重置参数，请求接口
        // this.resetQuery();
      }
    },
    //重置左侧筛选
    resetFilter(){
      this.latest = 1;
      //整理工作经验
      this.selectedeXperience = [];
      //整理院校
      this.selectedSchool = [];
      //整理学历
      this.selectedEducation = [];
      //重置参数，请求接口
      // this.resetQuery();
    },
    //重置参数，请求接口
    // resetQuery(){
    //   this.pageNo = 1;
    //   this.encodeURI();
    //   //重置列表数据
    //   this.resetResumeListObj();
    //
    //   this.isLoading = true;//是否在请求列表
    //   this.isQueryEnd = true;//是否请求完毕
    //   this.isFirstQuery = true;//是否是第一次请求
    //
    //   this.getList();
    //   //重置左侧职位选中index
    //   this.searchPositionIndex = -1;
    // },

    handlerToLogin (url) {
      toLogin(`${window.location.origin}${url}`)
    },
    // 获取用户信息
    async getUserinfo(){
      let userInfo = await actions.hr_accounts.getUserinfo({})
      this.toggleUserInfoState(userInfo);
    },
    //搜索提交
    async submit(){
      let query = {link_to: encodeURIComponent(`${window.location.origin}/talent/search/list?keyword=${this.keyword}&pageNo=1&latest=0&city=北京&education=${this.selectedEducation.join(',')}&schoolType=${this.selectedSchool.join(',')}&workYear=${this.selectedeXperience.join(',')}`) };
      //检查一下状态
      if(!this.checkPageState(query)){
        return false;
      }
      if(!this.keyword){
        return false;
      }
      this.$router.push({name:'talentSearchList',query:{keyword:this.keyword, pageNo: 1, latest: 0, city: '北京', education: this.selectedEducation.join(','), schoolType: this.selectedSchool.join(','), workYear: this.selectedeXperience.join(','), contact_directly: null}})
    },
    //【职位】点击职位
    clickJobs(item,index){
      //更新query的部分值
      let { id, job_post } = item.recruit_info;
      let query = {
        keyword: job_post,
        city: item.cities ? item.cities[0] : '',
        education: item.display_degree ? (item.display_degree==='学历不限' ? '' : this.jobType[item.display_degree])  : '',
        workYear: item.display_experience ? (item.display_experience==='经验不限' ? '' : (item.display_experience==='1年以下' ? '应届生' : item.display_experience) )  : '',
        job_id: id,
        searchPositionIndex:index,
        contact_directly: ''
      }
      this.$router.push({name:'talentSearchList',query})
    },
    //【热门】点击热门搜索
    clickHot(item){
      let query = {link_to: encodeURIComponent(`${window.location.origin}/talent/search/list?keyword=${item}`) };
      //检查一下操作状态
      if(!this.checkPageState(query)){
        return false;
      }
      this.$router.push({path: '/talent/search/list',query:{keyword:item}})
    },
    //【历史】点击历史搜索
    clickHistory(item){
      let query = {link_to: encodeURIComponent(`${window.location.origin}/talent/search/list?keyword=${item.keywords.join(',')}`) };
      //检查一下操作状态
      if(!this.checkPageState(query)){
        return false;
      }
      this.$router.push({path: '/talent/search/list',query:{keyword:item.keywords.join(',')}})
    },
    //检查一下操作状态
    checkPageState(query){
      //检查cookie中有没有userToken,主要判断登录状态
      let userJWT = get_tUser();
      let userToken = userJWT.t;
      if(!userToken){
        //增加登录之后自动跳转到相应页面
        toLogin()
        return false;
      }
      //不是hr 并且还不是新用户
      // if(!userJWT.h_t){
      //   //跳转到完善信息页面
      //   this.$router.push({name:'talentUserinfo',query });
      //   return false;
      // }
      return true;
    },
    // 去发职位
    toRecruitInfos(){
      if(!this.userJWT.t){
        //增加登录之后自动跳转到相应页面
        toLogin(`${window.location.origin}/talent/jobedit/create`)
      }else{
        window.location.href = '/talent/jobedit/create'
      }
    },
    // 切换搜索框样式
    toggleSearchInputBind(state){
      this.searchInputState = state;
      if(state){
        setTimeout(() => {
          this.$refs.searchInputState.focus();
        }, 10);
      }
    },
    //切换职位类别
    jobRecommendChange({item,index}){
      this.jobRecommend = {
        index,
        label: index === 0 ? '全部职位' : item.label
      }
      // 获取今日推荐简历
      this.getRecommendAtions();
    },
    // 获取今日推荐简历
    getRecommendAtions(){
      this.jobRecommendLoading = true;
      // this.recommendList = [];
      //重置列表信息
      this.updateResumeListObj({key:'searchIndex', value: []});
      
      actions.resumes.getRecommendAtions().then(res=>{
        this.jobRecommendLoading = false;
        //更新当前路由名字
        this.updateRoutePageName(this.$route.name);
        if(res.code === 1000){
          let { all_rec_resumes } = res.data;
          //整理职位筛选数据
          let jobTypeList = [{
            token:'',
            label:'全部职位'
          }]
          let all_rec_resumes2 = []
          all_rec_resumes.forEach(item=>{
            let rec_resumes = item.rec_resumes.filter(item => !item.unsuited);
            if(rec_resumes.length){
              jobTypeList.push({
                token:'',
                label: item.job_name,
              })
              all_rec_resumes2.push(item)
            }
            rec_resumes.forEach(sitem=>{
              sitem.job_id = item.job_id;
              sitem.resume.viewed = sitem.viewed;
              sitem.resume.unsuited = sitem.unsuited;
              //是否显示卡片
              sitem.unsuitableCardState = false;
            })
            item.rec_resumes = rec_resumes;
          })
          setTimeout(() => {
            this.jobTypeList = jobTypeList;

            if(this.routePageName === 'talentSearchIndex'){
              // 同步列表数据到vuex
              this.updateResumeListObj({key:'searchIndex', value: all_rec_resumes2});
            }

          }, 100);
        }else{
          this.jobTypeList = [{
            token:'',
            label:'不限'
          }];
        }
      })
    },
    
    //【详情】详情页通知列表修改状态
    changeListState(options){
      let resumeList = this.recommendList;
      if(!resumeList){
        return false;
      }
      let detailBIndex = '';
      let detailIndex = '';
      let detailItem = {};
      //匹配当前简历在列表中是否存在
      resumeList.forEach((item,index)=>{
        item.rec_resumes.forEach((sitem,sindex)=>{
          if(sitem.resume.token === (this.resumeDetailToken ||this.resumeDetail.resume.token||'')){
            detailBIndex = index;
            detailIndex = sindex;
            detailItem = sitem;
          }
        })
      })

      if(detailIndex !==''){
        if(options.type === 'is_favorite'){
          detailItem.is_favorite = options.value;
        }else if(options.type === 'hr_permission_state'){
          detailItem.hr_permission_state = options.value;
        }else if(options.type === 'unsuitable'){
          //修改拒绝状态
          detailItem.unsuited = options.value;
          // this.getRecommendAtions();
        }
        this.$set(this.recommendList[detailBIndex].rec_resumes,detailIndex,detailItem);

      }
    },

    //【手机号】同意获取手机号&&更新脱敏数据
    confirmGetPhone(profile_data){
      let { username, phone, email } = profile_data;
      let { profile } = this.resumeDetail.resume.info;
      profile.username = username;
      profile.phone = phone;
      profile.email = email;
      this.resumeDetail.hr_permission_state = 'passed';
      //同步状态到vuex中
      this.updateResumeDetail(this.resumeDetail)


      this.changeListState({type: 'hr_permission_state', value: 'passed'})

    },
    scrollTop(){
      if(!this.scrollTopNumber){
        this.scrollTopNumber = document.documentElement.scrollTop/10
      };
      //参数i表示间隔的幅度大小，以此来控制速度
      document.documentElement.scrollTop-=this.scrollTopNumber;
      if (document.documentElement.scrollTop>0) {
        var c=setTimeout(()=>this.scrollTop(this.scrollTopNumber),16);
      }else {
        this.scrollTopNumber = 0
        clearTimeout(c);
      }
      // scrollTo(0,0)
    },
    //清空历史消息
    clearHistory(){
      this.searchHistory = [];
      localStorage.setItem('searchHistory','[]');
    },
  },
  watch:{
    checkUnsuitable(newValue, oldValue){
      if(newValue){
        //重置列表
        this.jobRecommendChange({item:'', index:0});
        this.updateBlockStateFun({type:'checkUnsuitable', value: false})
      }
    },
  },
}
</script>
<style lang="scss" scoped>

@import './index.scss';
</style>
